import AnnualSubInfo from './annual-sub-info';

export default AnnualSubInfo;
